module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gl-633d308e7df9c5abcb8919eb401333e7.svg";